import { availableIcons, getIconById } from './profile/profileIcons'
import { getStoredProfile, storeProfile } from './profile/profileStorage'
import { saveProfileToServer } from './profile/profileAPI'
import { validateImageFile, fileToBase64 } from './profile/profileValidation'

export { availableIcons, validateImageFile, fileToBase64 }

// Get the display name for a user, prioritizing raveName over username
export const getUserDisplayName = (user) => {
  if (!user) return ''
  return user.profileSettings?.raveName || user.username || user.email || 'User'
}

const getDefaultProfile = () => ({
  profilePicture: null,
  selectedIcon: 'user',
  displayName: '',
  profileType: 'icon'
})

export const getProfile = (user = null) => {
  if (user && user.profileSettings) {
    return {
      profilePicture: user.profileSettings.profileType === 'picture' ? user.profilePicture : null,
      selectedIcon: user.profileSettings.selectedIcon || 'user',
      displayName: user.displayName || '',
      profileType: user.profileSettings.profileType || 'icon',
      raveName: user.profileSettings.raveName || '',
      favoriteFestival: user.profileSettings.favoriteFestival || '',
      favoriteGenre: user.profileSettings.favoriteGenre || '',
      tagline: user.profileSettings.tagline || ''
    }
  }

  return getStoredProfile() || getDefaultProfile()
}

export const saveProfile = async (profileData, saveToServer = true, refreshUserCallback = null) => {
  try {
    storeProfile(profileData)

    if (saveToServer) {
      await saveProfileToServer(profileData, refreshUserCallback)
    }

    return true
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.error('Error saving profile:', e)
    return false
  }
}

export const getDisplayAvatar = (user = null) => {
  const profile = getProfile(user)

  if (profile.profileType === 'picture' && profile.profilePicture) {
    return {
      type: 'picture',
      src: profile.profilePicture
    }
  }

  const selectedIconData = getIconById(profile.selectedIcon)
  return {
    type: 'icon',
    icon: selectedIconData.icon,
    name: selectedIconData.name
  }
}